import React from 'react';
import IconBase from './shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function CalendarDayOutlineIcon(props) {
  return ___EmotionJSX(IconBase, props, ___EmotionJSX("path", {
    d: "M16.5 3V3.5H17H21.5V19C21.5 20.3807 20.3807 21.5 19 21.5H5C3.61928 21.5 2.5 20.3807 2.5 19V3.5H7H7.5V3V2.5H8.5V3V3.5H9H15H15.5V3V2.5H16.5V3ZM4 4.5H3.5V5V19C3.5 19.8284 4.17153 20.5 5 20.5H19C19.8285 20.5 20.5 19.8284 20.5 19V5V4.5H20H17H16.5V5V6.5H15.5V5V4.5H15H9H8.5V5V6.5H7.5V5V4.5H7H4ZM16.5 11.5V13.5H14.5V11.5H16.5Z",
    fill: "currentColor",
    stroke: "currentColor"
  }));
}